import Index from './components/Index'

export default [
  {
    path: '/dashboard-2',
    name: 'dashboard-2-index',
    component: Index
  }
]
